/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_GreekInputs */

const en_speechmatics_target_language_greek = /** @type {(inputs: Speechmatics_Target_Language_GreekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Greek`)
};

const fr_speechmatics_target_language_greek = /** @type {(inputs: Speechmatics_Target_Language_GreekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grec`)
};

const de_speechmatics_target_language_greek = /** @type {(inputs: Speechmatics_Target_Language_GreekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`griechisch`)
};

const it_speechmatics_target_language_greek = /** @type {(inputs: Speechmatics_Target_Language_GreekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`greco`)
};

const ru_speechmatics_target_language_greek = /** @type {(inputs: Speechmatics_Target_Language_GreekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`греческий`)
};

const es_speechmatics_target_language_greek = /** @type {(inputs: Speechmatics_Target_Language_GreekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Griego`)
};

const zh_cn2_speechmatics_target_language_greek = /** @type {(inputs: Speechmatics_Target_Language_GreekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`希腊语`)
};

const ja_speechmatics_target_language_greek = /** @type {(inputs: Speechmatics_Target_Language_GreekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ギリシャ語`)
};

const hi_speechmatics_target_language_greek = /** @type {(inputs: Speechmatics_Target_Language_GreekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यूनानी`)
};

const pt_pt2_speechmatics_target_language_greek = /** @type {(inputs: Speechmatics_Target_Language_GreekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`grego`)
};

/**
* | output |
* | --- |
* | "Greek" |
*
* @param {Speechmatics_Target_Language_GreekInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_greek = /** @type {((inputs?: Speechmatics_Target_Language_GreekInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_GreekInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_greek(inputs)
	if (locale === "de") return de_speechmatics_target_language_greek(inputs)
	if (locale === "it") return it_speechmatics_target_language_greek(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_greek(inputs)
	if (locale === "es") return es_speechmatics_target_language_greek(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_greek(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_greek(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_greek(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_greek(inputs)
	return en_speechmatics_target_language_greek(inputs)
});